import type { ReactNode } from 'react';

type Variant = 'gold' | 'navy' | 'etf';

type Props = {
  variant?: Variant;
  title?: string;
  children: ReactNode;
  className?: string;
};

const BOX_VARIANTS: Record<Variant, string> = {
  gold: 'bg-secondary/10 border-secondary/35 text-[color:#fde8c8]',
  navy: 'bg-[color:var(--nq-surface-raised)] border-[color:var(--nq-line-soft)] text-[color:var(--text-secondary)]',
  etf: 'bg-primary/8 border-primary/28 text-[color:var(--text-secondary)]',
};

const TITLE_VARIANTS: Record<Variant, string> = {
  gold: 'text-secondary',
  navy: 'text-foreground',
  etf: 'text-[color:var(--nq-blue-bright)]',
};

const OnboardingInfoBox = ({
  variant = 'gold',
  title,
  children,
  className = '',
}: Props) => (
  <div
    className={[
      'my-3 rounded-lg border px-3 py-2.5 text-sm leading-normal',
      // nested lists in the body match the original navy variant spacing
      '[&_ul]:mt-1.5 [&_ul]:mb-0 [&_ul]:pl-4',
      BOX_VARIANTS[variant],
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    role="note"
  >
    {title ? (
      <strong
        className={[
          'mb-1 block font-display text-sm font-bold',
          TITLE_VARIANTS[variant],
        ].join(' ')}
      >
        {title}
      </strong>
    ) : null}
    <div className="[&_p]:m-0 [&_p]:text-[length:inherit] [&_p]:text-[color:inherit]">
      {children}
    </div>
  </div>
);

export default OnboardingInfoBox;
